<section class="w-100 float-left services_section">
    <div class="container">
        <div class="main_title d-flex justify-content-center" >
            <h1 class="line"><span>Our</span> Services </h1>
        </div>
        <h2 class="sub_title text-center w-100 float-left" >We offer end-to-end services in the IT
            domain ranging from customized mobile app development to enterprise web development.
        </h2>
        <div class="services_slider_main">
            <div class="slider row" id="services_slider" >
                <div class="col-sm-6 col-md-6 col-lg-3 col-12">
                <div class="slider_box slide float-left">
                    <img class="our_services_icons_fix" src="assets/images/home/MobileApplicationDevelopment.png" alt="Mobile App Development"/>
                    <div class="services_slider_title">Mobile App Development</div>
                    <div class="services_slider_text">Feature-rich apps with a seamless performance</div>
                </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-3 col-12">
                <div class="slider_box slide float-left">
                    <img class="our_services_icons_fix" src="assets/images/home/WebDevelopment.png" alt="Web Development"/>
                    <div class="services_slider_title">Web Development</div>
                    <div class="services_slider_text">Robust, reliable, and responsive corporate websites</div>
                </div>
            </div>
                <div class="col-sm-6 col-md-6 col-lg-3 col-12">
                <div class="slider_box slide float-left">
                    <!-- <img src="assets/images/inx_icons/our_services_home/Mobile_App_Development.png" /> -->
                    <img class="our_services_icons_fix" src="assets/images/home/DevOps.png" alt="DevOps"/>
                    <div class="services_slider_title">DevOps</div>
                    <div class="services_slider_text">Customized solutions by integrating technological advancements
                    </div>
                </div>
            </div>
                <div class="col-sm-6 col-md-6 col-lg-3 col-12">
                <div class="slider_box slide float-left">
                    <img class="our_services_icons_fix" src="assets/images/home/CloudComputing.png" alt="Cloud Computing"/>
                    <div class="services_slider_title">Cloud Computing</div>
                    <div class="services_slider_text">Secure and Scalable <br />Cloud-based Apps for Business</div>
                </div>
            </div>
                <!-- <div class=" float-left">
                    <img class="our_services_icons_fix" src="assets/images/home/Blockchain.png" alt="BlockChain"/>
                    <div class="services_slider_title">BlockChain</div>
                    <div class="services_slider_text">High-quality apps that <br /> gives the utmost <br />security
                    </div>
                </div> -->
            </div>
            <!-- <button class='leftRs'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="#060828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevron-left">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg></button> -->
            <!-- <button class='rightRs'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="#060828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevron-right">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button> -->
        </div>
        <div class="w-100 float-left text-center" >
            <button class="main_btn text-uppercase" routerLink="/contact-us">CONTACT US FOR FREE CONSULTANCY</button>
        </div>
    </div>
</section>